import { Box, Button, Container, Grid2, Input, Paper, styled, Typography } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";

export const PartHeaderBox = styled(Paper, { label: "PartDetails-Header" })(
    ({ theme }) => ({
        // backgroundColor: theme.palette.primary.main,
        
        height: 44,
        display: "flex",
        color: theme.palette.primary.dark,
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: 'none',
        borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,
        padding: 0,
    })
);

export const BoxContent = styled(Container, { label: "PartDetails-BoxContent" })(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        fontSize: 14,
        width: '100%',
        padding: '0 14px !important',
        "> img": {
            marginRight: 10,
        }
    })
);

export const BoxDescription = styled(Box, { label: "PartDetails-BoxDescription" })(
    ({ theme }) => ({
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    })
);

export const PartDetailsCode = styled(Typography, { label: "PartDetails-PartDetailsCode" })(
    ({ theme }) => ({
        display: "flex",
        alignItems: "center",
        fontWeight: StyleguideSavioFonts.bold,
        fontSize: 20,
        color: StyleguideSavioColors.text.grayTitles,
        padding: 6,

        "svg": {
            marginRight: 8,
            fontSize: 28,
            color: StyleguideSavioColors.grayBreadcrumb,
            "&:hover":{
                color: StyleguideSavioColors.grayBreadcrumb,
            }
        }
    })
);

export const BoxImagePreview = styled(Box, { label: "PartDetails-BoxImagePreview" })(
    ({ theme }) => ({
        width: 250,
        height: 250,
        border: '1px solid ' + StyleguideSavioColors.lighterGrey,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    })
);

export const ContainerInfoPreview = styled(Box, { label: "PartDetails-ContainerInfoPreview" })(
    ({ theme }) => ({
        justifyContent: 'flex-end',
        paddingLeft: 10,
        flexGrow: 0,
    })
);

export const PartImage = styled("img", { label: "PartDetails-PartImage" })(
    ({ theme }) => ({
        maxWidth: 200,
        maxHeight: 200,
    })
);

export const ContainerTextCart = styled(Box, { label: "PartDetails-ContainerTextCart" })(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        justifyContent: 'flex-end',
        ">span": {
            "&:nth-of-type(1)": {
                color: StyleguideSavioColors.text.black,
            },
            "&:nth-of-type(2)": {
                color: StyleguideSavioColors.mainBlue,
                marginLeft: 5,
                marginRight: 5,
                maxWidth: 125,
                overflowX: "hidden",
                textOverflow: "ellipsis",
            }
        }
    })
);

export const ContainerInputNumber = styled(Box, { label: "PartDetails-ContainerInputNumber" })(
    ({ theme }) => ({
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 20,
        alignItems: 'center',
        "input[type='number']": {
            border: '1px solid ' + StyleguideSavioColors.lightGrey,
            height: 33,
            boxSizing: 'border-box',
            borderLeft: 0,
            borderRight: 0,
            textAlign: 'center',
            fontSize: 14,
        },
        ".MuiInput-root": {
            boxShadow: 0,

            "&:before, &:after": {
                display: 'none',
            }
        }
    })
);

export const ContainerUom = styled(Box, { label: "PartDetails-ContainerUom" })(
    ({ theme }) => ({
       //fontSize: 14,
    })
);

export const InputQuantity = styled(Input, { label: "PartDetails-InputQuantity" })(
    ({ theme }) => ({
        // Per nascondere le frecce su Webkit (Chrome, Safari, Edge)
        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0,
        },
        // Per nascondere le frecce su Firefox
        "& input[type=number]": {
            MozAppearance: "textfield",
        },
    })
);

export const Unity = styled(Box, { label: "PartDetails-Unity" })(
    ({ theme }) => ({
        fontSize: 14,
        display: 'flex',
        marginTop: 10,
        justifyContent: 'flex-end',
        gap: 4,
        "*":{
            fontSize: 14,
        },
        ">p": {
            "&:first-of-type": {
                textTransform: 'uppercase',
                color: theme.palette.primary.main,
            },
            "&:last-of-type": {
                color: StyleguideSavioColors.text.black,
            }
        }
    })
);

export const SectionItems = styled(Box, { label: "PartDetails-SectionItems" })(
    ({ theme }) => ({
        width: "100%",
        height: "calc(100% - 290px)",
        overflow: "auto",
    })
);

export const BoxTabs = styled(Box, { label: "PartDetails-BoxTabs" })(
    ({ theme }) => ({
        borderTop: '1px solid ' + StyleguideSavioColors.lightGrey,
        borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,
        ".MuiTabs-root": {
            minHeight: 35,
        },
        "button": {
            overflow: 'visible',
            minHeight: 35,
            paddingTop:10,
            paddingBottom: 10,
            paddingLeft: 30,
            paddingRight: 30,
            textTransform: "uppercase",
            color: StyleguideSavioColors.text.grayTitles,
            width: 'calc(50% - 8px)',
            "&:last-of-type": {
                position: 'relative',
                "::after": {
                    content: "'/'",
                    position: "absolute",
                    fontSize: 27,
                    left: -12,
                    top: 1,
                    color: StyleguideSavioColors.lightGrey,
                    fontWeight: StyleguideSavioFonts.normal
                },
            },
            "&:nth-of-type(1)":{marginRight: 8,},
            "&:nth-of-type(2)":{marginLeft: 8,},
            "&.Mui-selected": {
               // fontWeight: StyleguideSavioFonts.bold,
            },
            "&:hover":{
                color: StyleguideSavioColors.blue,
            }
        },
        ".MuiTabs-indicator": {
            //display: 'none',
        },
        "~ div": {
            height: "calc(100% - 50px)",
            overflow: 'hidden',
            overflowY: 'auto',
        }
    })
);

export const RowTable = styled(Grid2, { label: "PartDetails-RowTable" })(
    ({ theme }) => ({
        display: 'flex',
        marginBottom: 7,

    })
);

export const TitleField = styled(Grid2, { label: "PartDetails-TitleField" })(
    ({ theme }) => ({
        width: 240,
        minWidth: 240,
        fontSize: 14,
        textAlign: 'right',
        height: '100%',
        color: StyleguideSavioColors.mainBlue,
        padding: 3,
        textTransform: 'uppercase',
        fontWeight: StyleguideSavioFonts.medium,
        "&:after":{
            content:"':'",
        }
    })
);

export const ValueField = styled(Grid2, { label: "PartDetails-ValueField" })(
    ({ theme }) => ({
        fontSize: 14,
        padding: 3,
        color: StyleguideSavioColors.text.black,
    })
);

export const RowGridButton = styled(Button, { label: "PartDetails-RowGrid2" })(
    ({ theme }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: "left",
        width: '100%',
        padding: '10px 20px',
        borderBottom: '1px solid ' + StyleguideSavioColors.lighterGrey,
        height: "100%",

        "&:hover": {
            textDecoration: 'underline !important',
            "&:before": {
                display: 'block',
                content: "''",
                width: 3,
                height: '100%',
                backgroundColor: StyleguideSavioColors.blue,
                left: 0,
                position: 'absolute',
                zIndex:1,
                
    
            },
        }
    })
);

export const BoxText = styled(Box, { label: "PartDetails-BoxText" })(
    ({ theme }) => ({
        "> *": {
            fontSize: 14,
            lineHeight: '19px',
        },
        ">p": {
            color: StyleguideSavioColors.text.black,
        },
        "h3": {
            color: StyleguideSavioColors.blue,
        }
    })
);

export const BoxIcon = styled(Box, { label: "PartDetails-BoxIcon" })(
    ({ theme }) => ({
        color: theme.palette.primary.main,
        "svg": { fontSize: 30, }
    })
);

export const Content = styled(Box, { label: "PartDetails-Content" })
    (({ theme }) => ({
        width: "100%"
    }))

export const NoResults = styled(Typography, { label: "PartDetails-NoResults" })
    (({ theme }) => ({
        width: "100%",
        padding: 20,
        textAlign: "center",
    }))